// extracted by mini-css-extract-plugin
export var banner = "_hl-0";
export var closeButton = "_hl-2";
export var greenCheckmark = "_hl-3";
export var hereLink = "_hl-4";
export var titleIcon = "_hl-1";